module.exports = __webpack_public_path__ + "static/img/42.849b2008.jpg";